module.exports = __webpack_public_path__ + "img/user-profile-white.26b01d57.png";